import { Map } from 'leaflet';
import PropTypes from 'prop-types';

export default PropTypes.instanceOf(Map);